﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
object RoomTypes {
    val list = listOf(
        "Single", "Double", "Twin", "Triple", "Quad",
        "Standard", "Superior", "Suite", "Junior Suite",
        "Executive", "Family", "Connecting", "Duplex"
    )
}

@Serializable
data class Room(
    val id: String? = null,
    @SerialName("tenant_id") val tenantId: String,
    @SerialName("room_type") val roomType: String,
    @SerialName("room_number") val roomNumber: String,
    val status: String = "CLEAN",
    @SerialName("created_at") val createdAt: String? = null
)

